import { render, staticRenderFns } from "./NotificationPush.vue?vue&type=template&id=04edee7a&"
import script from "./NotificationPush.vue?vue&type=script&lang=js&"
export * from "./NotificationPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports